




















import NavigationItems from '@/component/view/navigation/NavigationItems.vue';
import { CreateElement, VNode } from 'vue';
import { Component, Vue } from 'vue-property-decorator';
import SlideMenu from '@/component/view/navigation/SlideMenu.vue';

@Component<Navigation>({
  name: 'Navigation',
  components: {
    NavigationItems,
    SlideMenu,
  },
})
export default class Navigation extends Vue {
  showsSlideMenu = false;
}
